import { Img } from "@/components/image";
import type { SelectedAddon } from "@/features/addons/lib/aggregate-selected-addons";

// Number of overlapping thumbnails shown in the collapsed header before the
// remaining addons collapse into a "+N" counter.
const VISIBLE_THUMBNAILS = 2;

// Overlapping addon thumbnails displayed in the collapsed header of an addons
// summary row (configuration aside and cart list share the same look).
export const AddonThumbnails = ({ items }: { items: SelectedAddon[] }) => {
  const thumbnails = items.slice(0, VISIBLE_THUMBNAILS);
  const hiddenCount = items.length - thumbnails.length;

  return (
    <span className="flex items-center pr-1">
      {thumbnails.map((item) => (
        <span
          className="-ml-4 size-8 overflow-hidden rounded-full border border-brand-grey2 bg-brand-white first:ml-0"
          key={item.addon.id}
        >
          <Img
            alt={item.addon.name}
            className="size-full object-cover"
            height={32}
            src={item.addon.imageUrl ?? "/placeholder.svg"}
            width={32}
          />
        </span>
      ))}
      {hiddenCount > 0 && (
        <span className="-ml-4 flex size-8 items-center justify-center rounded-full border border-brand-grey2 bg-brand-grey1 text-brand-grey5 text-xs">
          +{hiddenCount}
        </span>
      )}
    </span>
  );
};
